// 使用方法參考
// async mounted() {
//     await this.handleAsyncTask(this.methodExampleA);
// },
// method: {
//     methodExampleA() {
//         this.data = await this.$store.dispatch('api/getDataPromise');
//     },
//     async methodExampleB() {
//         await this.handleAsyncTask(async () => {
//             const data = await this.$store.dispatch('api/postDataPromise');
//             await this.$router.push({
//                 name: 'Example',
//                 params: { id: data.serial }
//             });
//         });
//     },
// },

export default {
    data() {
        return {
            READ_INFO_BUSY: 'READ_INFO_BUSY',
        };
    },
    methods: {
        async handleAsyncTask(task) {
            await this.$store.dispatch('appendComponentBusy', this.READ_INFO_BUSY);
            try {
                const res = await task();
                return res;
            } catch (error) {
                // await this.$store.dispatch('showMsg', error.toString());
                throw new Error(error);
            } finally {
                await this.$store.dispatch('clearComponentBusy', this.READ_INFO_BUSY);
            }
        },
    }
}